import { toLocalDateStr } from '../../utils/helpers';
// ✅ Dashboard date range presetleri — Dashboard.jsx'ten ayrıldı (refactor)

export const presets = [
  { id: 'week', label: 'Bu Hafta' },
  { id: 'month', label: 'Bu Ay' },
  { id: '3months', label: '3 Ay' },
  { id: '6months', label: '6 Ay' },
  { id: 'year', label: 'Bu Yıl' },
  { id: 'all', label: 'Tümü' },
];

export const getDateRange = (preset) => {
  const now = new Date();
  const end = toLocalDateStr(now);
  let start;
  switch (preset) {
    case 'week': {
      const d = new Date(now); d.setDate(d.getDate() - 7);
      start = toLocalDateStr(d); break;
    }
    case 'month': {
      start = toLocalDateStr(new Date(now.getFullYear(), now.getMonth(), 1)); break;
    }
    case '3months': {
      const d = new Date(now); d.setMonth(d.getMonth() - 3);
      start = toLocalDateStr(d); break;
    }
    case '6months': {
      const d = new Date(now); d.setMonth(d.getMonth() - 6);
      start = toLocalDateStr(d); break;
    }
    case 'year': {
      start = toLocalDateStr(new Date(now.getFullYear(), 0, 1)); break;
    }
    case 'all': start = '2020-01-01'; break;
    default: start = toLocalDateStr(new Date(now.getFullYear(), now.getMonth(), 1));
  }
  return { start, end };
};

// ✅ Tek bir yılın tam aralığı (1 Ocak — 31 Aralık)
export const getYearRange = (year) => {
  const y = Number(year);
  return {
    start: `${y}-01-01`,
    end: `${y}-12-31`,
  };
};
